import React from "react";
import "./MiniBoard.css";

/**
 * Read-only Jeopardy mini-board thumbnail — category headers across the top and
 * three rows of value cells. The brand-loaded primitive: Korinna category
 * headers, Helvetica Inserat dollar values, gold-on-navy, Daily Doubles tinted.
 *
 * Theme-var-driven (--board-bg, --category-bg, --cell-bg, --cell-value,
 * --dd-bg, …) so a future per-game theme is just different vars on a wrapper —
 * no component change. Decoupled from the gameboard Redux slice (unlike the
 * interactive MiniGameBoard used in the controller).
 *
 * Props:
 *   categories:    string[]  — category labels (empty string → emptyLabel)
 *   values:        number[]  — value rows to show (default [200, 400, 600])
 *   dailyDoubles:  [col, row][] — positions to gold-tint
 *   emptyLabel:    placeholder for an unnamed category (default "—")
 */
const MiniBoard = ({
  categories = [],
  values = [200, 400, 600],
  dailyDoubles = [],
  emptyLabel = "—",
  className = "",
  style,
  ...rest
}) => {
  const cols = categories.length || 1;
  const isDD = (col, row) => dailyDoubles.some(([c, r]) => c === col && r === row);

  return (
    <div
      className={`gx-miniboard ${className}`}
      style={{ "--mb-cols": cols, ...style }}
      {...rest}
    >
      {categories.map((c, i) => (
        <div key={`cat-${i}`} className={`gx-mb-cat ${c ? "" : "is-empty"}`}>
          {c || emptyLabel}
        </div>
      ))}
      {values.map((v, row) =>
        categories.map((_, col) => (
          <div
            key={`cell-${row}-${col}`}
            className={`gx-mb-cell ${isDD(col, row) ? "is-dd" : ""}`}
          >
            {`$${v}`}
          </div>
        ))
      )}
    </div>
  );
};

export default MiniBoard;
